import React from "react";
import { UserDatPduliaDecode } from "../function/base64Function";
import { useSelector } from "react-redux";

export default function useValidationDataKonselor() {
  const store = useSelector(
    (state) => state.km_post_validation_sesssion_konseling
  );

  return {
    isValidUrl: !(
      (
        UserDatPduliaDecode().token == null ||
        store.data?.session?.token == null
      )
      // ||
      // store.data.token == null ||
      // typeof store.data.token == "string"
    ),
    dataValidationUser: {
      data: UserDatPduliaDecode(),
      raw: store.data,
    },
  };
}

// inData
//      idUserPduli: null,
//       session: null,
//       kodeVC: null,
//       typeUser: null,
//       token: null,
